enum AiImageQuality {
    STANDARD = 'standard',
    HD = 'hd',
}

export default AiImageQuality;
